import { Grid, styled } from '@mui/material'
import { MidmarkTypography } from '@midmark-enterprise/shared-components'
import { Form } from 'formik'

const StyledForm = styled(Form)({
    display: 'flex',
    flexGrow: 1,
    flexDirection: 'column',
    flexWrap: 'nowrap',
})

export const SignUpScrolledFormLayout = ({
    children,
    title,
    description,
    buttons,
}: {
    children: React.ReactNode | React.ReactNode[]
    title: string
    description?: string
    buttons?: React.ReactNode
}) => {
    return (
        <StyledForm autoComplete="off" data-testid="form-layout">
            <Grid
                sx={{
                    flex: 1,
                    '& > *:not(:last-child)': {
                        maxWidth: '100%',
                    },
                }}
                container
                wrap="nowrap"
                direction="column"
            >
                <MidmarkTypography
                    sx={{
                        mb: 2,
                        paddingLeft: '40px',
                    }}
                    variant="h3"
                    data-testid={DATA_TESTIDS.formTitleTextField}
                >
                    {title}
                </MidmarkTypography>

                {description && (
                    <MidmarkTypography sx={{ mb: 2 }} variant="body1">
                        {description}
                    </MidmarkTypography>
                )}

                <div
                    style={{
                        paddingLeft: '40px',
                        paddingRight: '8px',
                    }}
                >
                    {children}
                </div>
            </Grid>

            {buttons && (
                <Grid
                    container
                    direction="row"
                    wrap="nowrap"
                    justifyContent="space-between"
                    justifySelf="flex-end"
                    alignItems="center"
                    sx={{
                        marginTop: 'auto',
                        paddingTop: '20px',
                        '& > *:last-child': { marginLeft: 'auto' },
                        paddingRight: '56px',
                        paddingLeft: '40px',
                        boxShadow: '0px 0px 6px 0px rgba(0, 0, 0, 0.16)',
                    }}
                >
                    {buttons}
                </Grid>
            )}
        </StyledForm>
    )
}

const DATA_TESTIDS = {
    formTitleTextField: 'form-title-text-field',
}
